module.exports = __webpack_public_path__ + "img/percent-bg.979646ca.png";